// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames not based on template
	if (chunkId === 5118) return "static/chunks/5118.ea61ca480d6c37a2.js";
	// return url for filenames based on template
	return "static/chunks/" + chunkId + "-" + {"6044":"8f97811031066d7d","6842":"30e7d5318107331c","7366":"c51b929d4143afe6","8267":"f62536de41b7b40a"}[chunkId] + ".js";
};